import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { THEFT_SECURITY_OPTIONS } from '~/constants/domain-specific';
import { COVER_DETAILS_THEFT_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { Cover, DynamicCoverQuestionID } from '~/types/cover';
import { dynamicQuestionExists } from '~/utils';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

const ReviewTheft: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.theft' });

  const { theftContentsSI, tobaccoSI, security, dynamicCoverQuestions } = useCoverDetails();

  /**
   * @note since we store/cache each cover's details even if they have been removed (for state persistence),
   * we need a way to differentiate between a cached version of the dynamic question for a cover
   * that is currently active (since its possible that a cover has not been removed or updated,
   * but the underlying anszic has, which would invalidate the pre-filled dynamic question)
   */
  const showTobaccoSI = dynamicQuestionExists(
    dynamicCoverQuestions || [],
    Cover.Theft,
    DynamicCoverQuestionID.TOBACCO_SI
  );

  const theftReviewList = [
    {
      label: getTextContent('contents'),
      data: currencyFormatter(theftContentsSI, CurrencyFormat.Comma),
    },
    {
      label: getTextContent('tobacco'),
      data:
        tobaccoSI && showTobaccoSI
          ? currencyFormatter(tobaccoSI, CurrencyFormat.Comma)
          : getTextContent('noTobacco'),
    },
    {
      label: getTextContent('security'),
      data: THEFT_SECURITY_OPTIONS.find((o) => o.value === security)?.text,
    },
  ];

  return (
    <ReviewList
      list={
        theftReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={Cover.Theft}
      editRoute={COVER_DETAILS_THEFT_ROUTE}
    />
  );
};

export default ReviewTheft;
